import { useContext } from 'react';
import {
  HeroConversation,
  Product,
  ProductMessageData,
  UploadedFile,
  chatActions,
  useAppDispatch,
  useSendMediaMessage,
  useSendProductMessage,
  useSendTextMessage,
  AuthenticationContext,
} from '@vs-online-only-app/state';
import {
  createLocalMediaMessage,
  createLocalProductMessage,
  createLocalTextMessage,
} from '@vs-online-only-app/ui';

const useSendConversationMessages = ({
  conversation,
  textMessageBody,
  files,
  sharedProducts,
}: {
  conversation?: HeroConversation;
  textMessageBody: string;
  files: UploadedFile[];
  sharedProducts: Product[];
}) => {
  const dispatch = useAppDispatch();
  const { user } = useContext(AuthenticationContext);
  const sendTextMessageMutation = useSendTextMessage(conversation);
  const sendMediaMessageMutation = useSendMediaMessage(conversation);
  const sendProductMessageMutation = useSendProductMessage(conversation);

  const sendMessages = () => {
    if (!conversation) {
      return;
    }
    const author = user?.username as string;
    if (textMessageBody) {
      const localTextMessage = createLocalTextMessage({
        conversationId: conversation.id,
        author,
        body: textMessageBody,
      });
      dispatch(
        chatActions.addLocalMessage({
          conversationId: conversation.id,
          localMessage: localTextMessage,
        }),
      );
      sendTextMessageMutation.mutateAsync({
        messageBody: textMessageBody,
        localMessageId: localTextMessage.sid,
      });
    }

    if (sharedProducts.length) {
      sharedProducts.forEach((product) => {
        const localProductMessage = createLocalProductMessage({
          conversationId: conversation.id,
          product,
          author,
        });
        dispatch(
          chatActions.addLocalMessage({
            conversationId: conversation.id,
            localMessage: localProductMessage,
          }),
        );
        sendProductMessageMutation.mutateAsync({
          localMessageId: localProductMessage.sid,
          productData: localProductMessage.attributes
            .data as ProductMessageData,
        });
      });
    }

    if (files.length) {
      files.forEach((file) => {
        const localMediaMessage = createLocalMediaMessage({
          conversationId: conversation.id,

          author,
          mediaType: file.type.includes('video') ? 'video' : 'photo',
          mediaUrl: file.url,
        });
        dispatch(
          chatActions.addLocalMessage({
            conversationId: conversation.id,
            localMessage: localMediaMessage,
          }),
        );
        sendMediaMessageMutation.mutateAsync({
          localMessageId: localMediaMessage.sid,
          mediaFile: file,
        });
      });
    }
  };

  return { sendMessages };
};

export default useSendConversationMessages;
